import * as React from 'react';

import type {DripEdition} from '../drip-sequence-list-item/drip-sequence-list-item';
import type {DripSequenceStatus} from '../edition/get-edition-status-info';
import {TwoLineMiniCard} from '../two-line/two-line-mini-card';

import {getDripSequenceTriggerColor} from './get-drip-sequence-trigger-color';
import {getDripSequenceTriggerIcon} from './get-drip-sequence-trigger-icon';

import styles from './drip-sequence-preview.module.css';

export type DripSequence = {
    htmlUrlPath?: string;
    startTrigger?:
        | {
              humanReadableTitle: string;
              humanReadableSubtitle: string;
              id: string;
          }
        | null
        | undefined;
    status: DripSequenceStatus;
};

type Props = {
    dripSequence: DripSequence;
    dripEditions?: DripEdition[];
    isLoading?: boolean;
    isThumbnail?: boolean;
};

export function DripSequencePreview(props: Props) {
    const {dripSequence, dripEditions, isLoading} = props;

    const isTriggerEditable = Boolean(
        props.dripSequence &&
            props.dripSequence.status !== 'CANCELLED' &&
            props.dripSequence.status !== 'RETIRED'
    );

    const dripItems = dripEditions
        ? dripEditions.map((drip) => (
              <TwoLineMiniCard
                  key={`drip-${drip.id}`}
                  isThumbnail={props.isThumbnail}
                  to={drip.htmlUrlPath}
                  topRow={drip.name}
                  bottomRow={drip.secondaryInfo}
                  // @ts-expect-error
                  isLargeWithSmallBottomRow={true}
                  hasBoldTopRow={true}
                  isGrey={true}
              />
          ))
        : undefined;

    return (
        <div className={styles['drip-sequence-preview']}>
            {dripSequence.startTrigger ? (
                <TwoLineMiniCard
                    isThumbnail={props.isThumbnail}
                    to={dripSequence.htmlUrlPath}
                    onClick={() => {
                        if (isTriggerEditable && dripSequence.startTrigger) {
                            // Flow doesn't believe this exists
                            NutClientConfig.isEditingStartTrigger = dripSequence.startTrigger.id;
                        }
                    }}
                    icon={getDripSequenceTriggerIcon(dripSequence.status)}
                    iconColor={getDripSequenceTriggerColor(dripSequence.status)}
                    iconSize={20}
                    topRow={dripSequence.startTrigger.humanReadableTitle}
                    bottomRow={dripSequence.startTrigger.humanReadableSubtitle}
                    // @ts-expect-error
                    isLargeWithSmallBottomRow={true}
                    borderColor={getDripSequenceTriggerColor(dripSequence.status)}
                />
            ) : undefined}
            {dripItems && dripItems.length ? dripItems : undefined}
            {isLoading && (!dripItems || !dripItems.length) && (
                <div className={styles.empty}>Loading…</div>
            )}
            {!isLoading && !dripSequence.startTrigger && (!dripItems || !dripItems.length) && (
                <div className={styles.empty}>This drip sequence is empty</div>
            )}
        </div>
    );
}
